import BaseService from './BaseService';

const mapV2ListToV1 = response => ({
  actionStatus: {
    status: "SUCCESS"
  },
  invoices: response.data || []
})

const INVOICE_TYPE_CODE_COMMERCIAL_INVOICE = 'COM';
class InvoiceService extends BaseService {

	constructor() {
		super();
		this.serviceUrl = "/api/rest/invoice";
    this.serviceUrlListV2 = "/api/rest/v2/generic/all/invoice";
	}

	list(customerCode) {
		return this.opencellAPI
      .invokeRequest(
        {
          filters: {
            "billingAccount.customerAccount.customer.code": customerCode
          },
          nestedEntities: [
            "billingAccount.customerAccount.customer"
          ]
        },
        this.serviceUrlListV2,
        "POST"
      )
      .then(mapV2ListToV1);
	}

	listPresentInAR(ca) {
		let url = this.serviceUrl + '/list?includePdf=true&customerAccountCode=' + ca.code;
		return this.opencellAPI.callApi(url);
	}

	listInvoicesBySubCode(subscriptionCode) {
		return this.opencellAPI
      .invokeRequest(
        {
          filters: {
            SQL: `a.billingAccount.id  in  (select  ua.billingAccount  from  org.meveo.model.billing.UserAccount  ua  where  ua.id  in  (select  s.userAccount  from  org.meveo.model.billing.Subscription  s  where  s.code='${subscriptionCode}'))`,
            "invoiceType.code": INVOICE_TYPE_CODE_COMMERCIAL_INVOICE
          },
          nestedEntities: [
            "billingAccount.usersAccounts.subscriptions"
          ]
        },
        this.serviceUrlListV2,
        "POST"
      )
      .then(mapV2ListToV1)
	}

	find(code) {
		let url = '/api/rest/catalog/offerTemplate?offerTemplateCode=' + code;
		return this.opencellAPI.callApi(url);
	}

  downloadPdf(id) {
    let url = `/api/rest/v2/billing/invoices/${id}/pdf?generateIfMissing=true`;
		return this.opencellAPI.callApi(url);
  }

}

const invoiceService = new InvoiceService();

export default invoiceService;



// WEBPACK FOOTER //
// ./src/opencell/services/InvoiceService.js